/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Metric_VolumeInputs */

const en_us2_exercise_sheet_metric_volume = /** @type {(inputs: Exercise_Sheet_Metric_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const pt_br2_exercise_sheet_metric_volume = /** @type {(inputs: Exercise_Sheet_Metric_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const es_419_exercise_sheet_metric_volume = /** @type {(inputs: Exercise_Sheet_Metric_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen`)
};

const pt_pt2_exercise_sheet_metric_volume = /** @type {(inputs: Exercise_Sheet_Metric_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const fr_fr2_exercise_sheet_metric_volume = /** @type {(inputs: Exercise_Sheet_Metric_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const de_de2_exercise_sheet_metric_volume = /** @type {(inputs: Exercise_Sheet_Metric_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen`)
};

const it_it2_exercise_sheet_metric_volume = /** @type {(inputs: Exercise_Sheet_Metric_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

/**
* | output |
* | --- |
* | "Volume" |
*
* @param {Exercise_Sheet_Metric_VolumeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_metric_volume = /** @type {((inputs?: Exercise_Sheet_Metric_VolumeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Metric_VolumeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_metric_volume(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_metric_volume(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_metric_volume(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_metric_volume(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_metric_volume(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_metric_volume(inputs)
	return en_us2_exercise_sheet_metric_volume(inputs)
});
export { exercise_sheet_metric_volume as "exercise-sheet.metric_volume" }